// Paints the peaks from audio_peaks.js onto a canvas, with the selected 30s lit up (#122).
//
// Colours are read off the canvas as custom properties rather than hardcoded here, so the
// waveform follows tokens.css into dark mode like every other component - the caller just
// has to repaint when the scheme flips.

const BAR_WIDTH = 2
const BAR_GAP = 1
const MIN_BAR_HEIGHT = 2

export function drawWaveform(canvas, peaks, { start = 0, end = 0, duration = 0 } = {}) {
  const context = canvas.getContext("2d")
  if (!context) return

  const ratio = window.devicePixelRatio || 1
  const width = canvas.clientWidth
  const height = canvas.clientHeight
  if (width === 0 || height === 0) return

  // Setting width/height also clears the canvas, so this doubles as the wipe.
  canvas.width = Math.round(width * ratio)
  canvas.height = Math.round(height * ratio)
  context.setTransform(ratio, 0, 0, ratio, 0, 0)

  if (!peaks || peaks.length === 0) return

  const styles = getComputedStyle(canvas)
  const base = color(styles, "--wave-color", "#9ca3af")
  const selected = color(styles, "--wave-color-selected", "#111827")
  const bars = Math.max(1, Math.floor((width + BAR_GAP) / (BAR_WIDTH + BAR_GAP)))
  const middle = height / 2

  for (let bar = 0; bar < bars; bar++) {
    const level = peakOfBar(peaks, bar, bars)
    const barHeight = Math.max(MIN_BAR_HEIGHT, level * (height - MIN_BAR_HEIGHT))
    const x = bar * (BAR_WIDTH + BAR_GAP)
    const at = duration > 0 ? ((bar + 0.5) / bars) * duration : 0

    context.fillStyle = duration > 0 && at >= start && at < end ? selected : base
    context.fillRect(x, middle - barHeight / 2, BAR_WIDTH, barHeight)
  }
}

// The peaks array is fixed-size, so a narrow canvas folds several buckets into one bar and a
// wide one repeats them - either way the loudest bucket wins, which is what keeps a drop
// visible at 380 px.
function peakOfBar(peaks, bar, bars) {
  const from = Math.floor((bar / bars) * peaks.length)
  const to = Math.max(from + 1, Math.floor(((bar + 1) / bars) * peaks.length))
  let peak = 0

  for (let bucket = from; bucket < to && bucket < peaks.length; bucket++) {
    if (peaks[bucket] > peak) peak = peaks[bucket]
  }

  return peak
}

function color(styles, property, fallback) {
  return styles.getPropertyValue(property).trim() || fallback
}
